import type { Tab } from 'modules/core/components/Card/types'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import type { Navigation } from 'modules/core/lib/navigation/context'
import type { NavigationPaths } from 'modules/core/lib/navigation/context'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

const TabTypes = {
  edit: 'edit',
  preferences: 'preferences',
  work_time_categories: 'work_time_categories',
  compensation: 'compensation',
  employees: 'employees',
  breaks: 'breaks',
}

const buildTabs = (
  attendanceSetting: AttendanceSetting,
  navigation: Navigation<NavigationPaths>
): Tab[] => {
  const settingId = attendanceSetting.attributes.id
  const hasMajorationEnabled = hasFeature('dev_time_tracking_majoration')
  const hasBankOfHours = hasFeature('dev_time_tracking_bank_of_hours')

  const tabs = [
    {
      name: i18n.t('time_tracking.settings.tabs.policy_settings'),
      index: true,
      href: navigation.settings.time_tracking.settingId.tabId.fullPath({
        settingId,
        tabId: TabTypes.edit,
      }),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.preferences'),
      index: false,
      href: navigation.settings.time_tracking.settingId.tabId.fullPath({
        settingId,
        tabId: TabTypes.preferences,
      }),
    },
    ...(hasMajorationEnabled || hasBankOfHours
      ? [
          {
            name: i18n.t('time_tracking.settings.tabs.work_time_categories'),
            index: false,
            href: navigation.settings.time_tracking.settingId.tabId.fullPath({
              settingId,
              tabId: TabTypes.work_time_categories,
            }),
          },
        ]
      : []),
    {
      name: i18n.t('time_tracking.settings.tabs.compensation'),
      index: false,
      href: navigation.settings.time_tracking.settingId.tabId.fullPath({
        settingId,
        tabId: TabTypes.compensation,
      }),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.breaks'),
      index: false,
      href: navigation.settings.time_tracking.settingId.tabId.fullPath({
        settingId,
        tabId: TabTypes.breaks,
      }),
    },
    {
      name: i18n.t('time_tracking.settings.tabs.employees'),
      index: false,
      href: navigation.settings.time_tracking.settingId.tabId.fullPath({
        settingId,
        tabId: TabTypes.employees,
      }),
    },
  ]

  return tabs
}

export { TabTypes, buildTabs }
